var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uButton: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-button/u-button" */ "uview-ui/components/u-button/u-button.vue"
      )
    },
    uModal: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-modal/u-modal" */ "uview-ui/components/u-modal/u-modal.vue"
      )
    },
    uPopup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
      )
    },
    "u-Form": function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u--form/u--form" */ "uview-ui/components/u--form/u--form.vue"
      )
    },
    uFormItem: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-form-item/u-form-item" */ "uview-ui/components/u-form-item/u-form-item.vue"
      )
    },
    "u-Input": function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u--input/u--input" */ "uview-ui/components/u--input/u--input.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.info ? [13].includes(_vm.info.status) : null
  var g1 = _vm.info ? [11, 12, 13].includes(_vm.info.status) : null
  var g2 =
    _vm.info && g1
      ? [11].includes(_vm.info.status) && _vm.info.feeUpdate === 0
      : null
  var g3 =
    _vm.info && g1
      ? [11].includes(_vm.info.status) && _vm.info.feeUpdate === 1
      : null
  var g4 =
    _vm.info && g1 && !g3
      ? [11].includes(_vm.info.status) && _vm.info.feeUpdate === 0
      : null
  var g5 = _vm.info && g1 ? [11].includes(_vm.info.status) : null
  var g6 = _vm.info && g1 ? [11].includes(_vm.info.status) : null
  var g7 = _vm.info ? [10, 11, 12].includes(_vm.info.status) : null
  var g8 = _vm.info
    ? [9].includes(_vm.info.status) && _vm.info.waitSupplement === 1
    : null
  var g9 = _vm.info ? [6, 8].includes(_vm.info.status) : null
  var g10 = _vm.info ? [4].includes(_vm.info.status) : null
  var m0 = _vm.info ? _vm.returnInHospital(_vm.info.inHospital) : null
  var m1 = _vm.info ? _vm.returnName(_vm.info.hurtType) : null
  var m2 = _vm.info ? _vm.returnName(_vm.info.medicalInsurance) : null
  var l0 =
    _vm.info && _vm.info && _vm.info.settleClaimsLogList
      ? _vm.__map(_vm.info.settleClaimsLogList, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var g11 = _vm.info.settleClaimsLogList.length
          var g12 = _vm.info.settleClaimsLogList.length
          var g13 = item.content ? _vm.info.settleClaimsLogList.length : null
          var g14 =
            item.content && item.objType === 3
              ? JSON.parse(item.afterContent)
              : null
          var g15 =
            item.content && item.objType === 3
              ? JSON.parse(item.afterContent)
              : null
          var g16 =
            item.content && item.objType === 3
              ? JSON.parse(item.afterContent)
              : null
          var g17 =
            item.content && item.objType === 3
              ? JSON.parse(item.afterContent)
              : null
          var g18 =
            item.content && item.objType === 3
              ? JSON.parse(item.afterContent)
              : null
          return {
            $orig: $orig,
            g11: g11,
            g12: g12,
            g13: g13,
            g14: g14,
            g15: g15,
            g16: g16,
            g17: g17,
            g18: g18,
          }
        })
      : null
  var g19 = _vm.info
    ? [1, 2, 3, 4, 5, 9, 7, 10].includes(_vm.info.status)
    : null
  var g20 = _vm.info
    ? ([9].includes(_vm.info.status) && _vm.info.waitSupplement === 1) ||
      [1, 2, 4, 5, 7].includes(_vm.info.status)
    : null
  var g21 = _vm.info
    ? [9].includes(_vm.info.status) && _vm.info.waitSupplement === 1
    : null
  var g22 = _vm.info ? [1, 2, 4, 5, 7].includes(_vm.info.status) : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.show = true
    }
    _vm.e1 = function ($event) {
      _vm.show = false
    }
    _vm.e2 = function ($event) {
      _vm.show1 = false
    }
    _vm.e3 = function ($event) {
      _vm.show2 = false
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        g2: g2,
        g3: g3,
        g4: g4,
        g5: g5,
        g6: g6,
        g7: g7,
        g8: g8,
        g9: g9,
        g10: g10,
        m0: m0,
        m1: m1,
        m2: m2,
        l0: l0,
        g19: g19,
        g20: g20,
        g21: g21,
        g22: g22,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }